export const FINANCIAL_API = `v1/financial-reporting`;
